import { useLoggedInUserStore } from '~/stores/loggedInUser'

export function getCanSeeSplitFraction({
  callingFn,
}: {
  callingFn: string
}): boolean {
  const fn = `[cynqueModules/dataObjects/SplitFraction.ts] getCanSeeSplitFraction `
  // Reads the Pinia store directly, exactly as plugins/getLoggedInTeamMember.ts
  // does. This was `window?.$nuxt?.$getLoggedInTeamMember()?...`; Nuxt 4 removed
  // that global, so the optional chain short-circuited to undefined and the
  // `?? false` left isCommissionManager PERMANENTLY false here -- silently
  // hiding split fractions from the commission managers meant to see them.
  const canSeeSplitFraction =
    useLoggedInUserStore().getLoggedInTeamMember?.isCommissionManager ?? false
  console.debug(`${callingFn} --> ${fn}: ${canSeeSplitFraction}`)
  return canSeeSplitFraction
}

export const SPLIT_FRACTION_IFIELD_NAME = 'splitFraction'
export const SPLIT_FRACTION_HEADER_VALUE = 'splitFraction'
